import { queryOptions } from "@tanstack/react-query";

import {
  getMyCoachLeadFn,
  getMyCoachLeadStatsFn,
  listMyCoachLeadsFn,
} from "~/lib/functions/coach-leads";

export const myCoachLeadsQueryKey = ["coach-leads", "mine"] as const;

export function myCoachLeadsQueryOptions() {
  return queryOptions({
    queryKey: myCoachLeadsQueryKey,
    queryFn: () => listMyCoachLeadsFn(),
  });
}

export function myCoachLeadQueryOptions(leadId: string) {
  return queryOptions({
    queryKey: [...myCoachLeadsQueryKey, leadId] as const,
    queryFn: () => getMyCoachLeadFn({ data: { leadId } }),
  });
}

export function myCoachLeadStatsQueryOptions() {
  return queryOptions({
    queryKey: [...myCoachLeadsQueryKey, "stats"] as const,
    queryFn: () => getMyCoachLeadStatsFn(),
  });
}
